export function IntegrationsTabSkeleton() {
    return (
        <div className="flex flex-col gap-6 pt-14">
            <div className="h-[52px] w-full skeleton-item rounded-md" />
            <div className="flex flex-col gap-2">
                {[1, 2].map((i) => (
                    <div
                        key={i}
                        className="skeleton-item-container border border-grey-600 rounded-[10px] p-4 flex items-center justify-between gap-3"
                    >
                        <div className="flex items-center gap-3">
                            <div className="size-5 skeleton-item rounded" />
                            <div className="h-4 w-32 skeleton-item rounded" />
                        </div>
                        <div className="h-5 w-20 skeleton-item rounded" />
                    </div>
                ))}
            </div>
        </div>
    );
}
